module.exports = __webpack_public_path__ + "img/analysis_icon.cdef8a5e.png";